export const storyblokProductSearchFiltersParseStringArrayToQueryString = (
  fieldName: string,
  values: string[],
): string | null => {
  let normalizedValues = values.map((value) => value.trim()).filter(Boolean)
  // remove duplicates
  normalizedValues = [...new Set(normalizedValues)]

  if (normalizedValues.length === 0) {
    return null
  }

  if (normalizedValues.length === 1) {
    return `${fieldName}:${normalizedValues[0]}`
  }

  const joinedValues = normalizedValues
    .map((value) => `${fieldName}:${value}`)
    .join(' OR ')

  return `(${joinedValues})`
}
